import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const NumbersAssignedPlansDropdown = ({
    data,
    accountScope,
    setCurrentNumber,
    errors,
    touched,
    darkMode,
    assignedPlans,
}) => {
    const handleSelectChange = (item) => {
        setCurrentNumber((prev) => ({
            ...prev,
            planID: item.id,
        }));
    };

    const [isHovered, setIsHovered] = useState(false);
    const fieldName = 'formValues[0].assignedPlans';

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={errors?.assignedPlans && touched?.assignedPlans}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>Plans</FormLabel>
                </Box>
                <Field
                    component={DropDown}
                    id={fieldName}
                    name={fieldName}
                    shownValue="name"
                    currentId={data?.planID}
                    handleSelectChange={handleSelectChange}
                    accountScope={accountScope}
                    darkMode={darkMode}
                    data={assignedPlans}
                    data-walkthroughid={
                        walkthroughIds.editNumbersGeneral.ufAssignedPlans
                    }
                />
                {isHovered && (
                    <FieldToolTip
                        label="Plan assigned to the Number"
                        ariaLabel="numbers-plans-dropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default NumbersAssignedPlansDropdown;
